import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getFeedKey, getPostKey, getPostsKey } from '../../utils/keys';
import { addPostToPaginatedPost, postRepliesUpdater, infinitePostUpdater, infinitePostArrayUpdater, getCachedPost, } from '../cache/useCachedPost';
import { pinnedPostsFilter } from './filters';
const onAddReply = (variables, newPost, queryClient) => {
    const { postId } = variables;
    /** Add the reply to the parent post.replies query */
    const rootPostKey = getPostKey({ variables: { id: postId } });
    const rootPostSnapshot = getCachedPost(postId, queryClient);
    if (rootPostSnapshot) {
        queryClient.setQueriesData(rootPostKey, postRepliesUpdater(newPost));
    }
    /**
     * Add the reply to the replies queries
     * (inactive/disabled queries are the replies to reply ones so we also update them to show the feedback)
     * */
    const repliesKey = {
        queryKey: getPostsKey(),
        predicate: query => {
            var _a, _b, _c;
            const args = (_a = query === null || query === void 0 ? void 0 : query.queryKey) === null || _a === void 0 ? void 0 : _a[1];
            return ((_c = (_b = args) === null || _b === void 0 ? void 0 : _b.variables) === null || _c === void 0 ? void 0 : _c.postId) === postId;
        },
    };
    const repliesSnapshot = queryClient.getQueriesData(repliesKey);
    if (repliesSnapshot) {
        queryClient.setQueriesData(repliesKey, addPostToPaginatedPost(newPost));
    }
    /** Add reply to the pinned posts */
    const pinnedPostsSnapshot = queryClient.getQueriesData(pinnedPostsFilter);
    if (pinnedPostsSnapshot) {
        queryClient.setQueriesData(pinnedPostsFilter, oldPosts => oldPosts.map(infinitePostArrayUpdater(postId, postRepliesUpdater(newPost), false)));
    }
    /**  Add the reply to Post.replies in any posts/feed queries which the parent post exists */
    // get all active posts query
    const postsQueryFilter = {
        active: true,
        predicate: query => {
            var _a;
            const [main, args] = (query === null || query === void 0 ? void 0 : query.queryKey) || [];
            if (((_a = args) === null || _a === void 0 ? void 0 : _a.postId) !== postId &&
                (main === getFeedKey()[0] || main === getPostsKey()[0])) {
                return true;
            }
            return false;
        },
    };
    // take a snapshot from all matched posts queries
    const postsSnapshots = queryClient.getQueriesData(postsQueryFilter);
    // update replies within the found post everywhere (posts and the feed queries)
    queryClient.setQueriesData(postsQueryFilter, infinitePostUpdater(postId, postRepliesUpdater(newPost), false));
    return {
        postsSnapshots,
        rootPostSnapshot,
        repliesSnapshot,
        pinnedPostsSnapshot,
    };
};
export const useAddReply = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((input) => client.posts.reply(input.postId, input, fields), {
        onSuccess: (data, variables) => {
            onAddReply(variables, data, queryClient);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useAddReply.js.map